import React, { useRef, useEffect } from 'react';
import s from './s.module.less';
import AvatarGroup from 'components/AvatarGroup';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { Button, Modal } from 'antd';
import IntroImage from './images/intro.png';
import usePPAChanneld from 'hooks/usePPAChanneld';
import { getHasShownReminderBanner, setHasShownReminderBanner } from 'utils/localstore';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';

type Props = {
    onClickDismiss?: () => void;
};

// hard code two provider
// ppa link: https://www.youtube.com/watch?v=jy8oVJ2aCF4
// https://www.helloklarity.com/provider/derek-timbs?state=texas&condition=weight-loss
// https://www.helloklarity.com/provider/kelly-cobb?state=florida&condition=adhd

const ReminderBanner = (props: Props) => {
    const { onClickDismiss } = props;
    const navigate = useNavigate();
    const [openModal, setOpenModal] = React.useState(false);
    const hasClicked = useRef(false);
    const [homeInfo, loadingHome] = useProviderHomeInfo();
    const isShowBanner =
      !getHasShownReminderBanner() &&
      !homeInfo?.practiceAndPaymentSetUpCompleted;

    const openPPAChannel = () => {
        navigate(
            `/${PATH.PAYMENT_SETUP}`,
        );
    };

    const handleSetUpNoShowPolicy = () => {
        hasClicked.current = true;
        setHasShownReminderBanner(true);
        localStorage.setItem('reminderBannerShown', 'true');
        setOpenModal(true);
    };

    useEffect(() => {
        const hasShownModal =
        localStorage.getItem('reminderBannerShown');
        if (!hasShownModal && isShowBanner) {
            const timer = setTimeout(() => {
                if (!hasClicked.current) {
                    setOpenModal(true);
                    localStorage.setItem('reminderBannerShown', 'true');
                }
            }, 10000);

            return () => clearTimeout(timer);
        }
    }, []);
    return (
        <div>
            {isShowBanner && (
                <div className={s.wrap}>
                    <div className={s.left}>
                        <div className={s.label}>Only 3 minutes to complete</div>
                        <div className={s.title}>
                            💳 Get paid for no-shows — set your policy and payment details
                        </div>
                        <div className={s.des}>
                            Protect your time and reduce missed appointments. Set your policy
                            for no-shows, late cancellations, and rescheduling, and start
                            collecting fees automatically.
                        </div>
                    </div>
                    <div className={s.right}>
                        <AvatarGroup />
                        <p>Trusted by thousands of providers</p>
                        <span
                            className={s.btn}
                            onClick={() => handleSetUpNoShowPolicy()}
                        >
                            Set up no-show policy
                        </span>
                    </div>
                </div>
            )}
            <Modal
                footer={null}
                title=""
                open={openModal}
                onCancel={() => {
                    setOpenModal(false);
                }}
                destroyOnClose
                centered
                width={708}
            >
                <div className={s.modalWrap}>
                    <div className={s.title}>
                        💳 Get paid for no-shows — set your policy and payment details
                    </div>
                    <div className={s.des}>
                        Protect your time and reduce missed appointments. Set your policy
                        for no-shows, late cancellations, and rescheduling, and start
                        collecting fees automatically.
                    </div>
                    <div className={s.imageWrap}>
                        <img src={IntroImage} alt="intro" />
                    </div>
                    <div className={s.btnWrap}>
                        <Button
                            onClick={() => {
                                openPPAChannel();
                            }}
                            size="large"
                            className={s.btn}
                            type="primary"
                            block
                        >
                            Set up no-show policy
                        </Button>
                        <div className={s.tips}>
                            Only <b>3 minutes</b> left to complete your onboarding
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ReminderBanner;
